import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite, TweenLite} from "gsap";
import {DirtyWildsSpineAnimationNames} from "../../../config/DirtyWildsSpineAnimationNames";
import {DirtyWildsTextStyles} from "../../../config/DirtyWildsTextStyles";
import {DirtyWildsGameAssets} from "../../DirtyWildsGameAssets";
import {DirtyWildsSoundConfig} from "../../DirtyWildsSoundConfig";


/**
 * Created by Jonas Wålekvist on 2018-09-04.
 */

export class SpinsLeftMeterView extends PIXI.Container {
    private _dynamicText:PIXI.BitmapText;
    private _currentValue:number = -1;
    private _active:boolean = false;
    private _showThreshold:number;
    private _numberFire:PIXI.spine.Spine;
    private _number:PIXI.spine.Spine;
    private _numberLastAnim:string;

    constructor(threshold:number) {
        super();
        this._showThreshold = threshold;

        this._dynamicText = new PIXI.BitmapText("0", DirtyWildsTextStyles.TOP_BAR_NUMBER_STYLE_FS);
        this._dynamicText.anchor = new PIXI.Point(0.5, 0.5);
        this._dynamicText.position.set(-256, -171);
        this._dynamicText.alpha = 0;

        this._numberFire = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.TOP_BAR_NUMBER_FIRE));
        this._number = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.TOP_BAR_NUMBER));
        this._numberFire.position.set(-258, -177);
        this._number.position.set(-258, -177);
        this.addChild(this._numberFire);
        this.addChild(this._dynamicText);
        this.addChild(this._number);
    }


    public getUpdateTickAnimation(value:number):TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        if(value == this._currentValue) {
            if(this._numberLastAnim !== DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_TEXT_STOP) {
                this._numberLastAnim = DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_TEXT_STOP;
                tl.add(new SpineTween(this._numberFire, 1, DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_TEXT_STOP));
            }
            return tl;
        }

        if(this._active && value <= this._showThreshold) {
            this._active = false;
            tl.add([
                this.getTurnOffAnimation(),
                this.getTickDownAnimation(value)
            ]);
            this._currentValue = value;
            return tl;
        }

        if(!this._active && value > this._showThreshold) {
            this._active = true;

        }


        if(value < this._currentValue) {
            tl.add(this.getTickDownAnimation(value));
        } else {
            tl.add(() => this.getTurnOnAnimation());
            tl.add(this.getTickUpAnimation(value));
        }

        this._currentValue = value;
        return tl;
    }

    private getTickDownAnimation(value:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            this.getTextTickAnimation(value)
        ]);
        return tl;
    }

    private getTickUpAnimation(value:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        //tl.add(new SpineTween(this._numberFire, 1, "topBarMoveGlowLeft"));
        tl.add([
            () => SlotGame.sound.playEffect(DirtyWildsSoundConfig.SPIN_COUNTER_UP),
            this.getTextTickAnimation(value, true)
        ]);


        return tl;
    }

    private clearText() {
        this._dynamicText.alpha = 0;
        this._dynamicText.text = "";
    }

    private setText(value:number) {
        this._dynamicText.text = "" + value;
    }

    private getTextTickAnimation(value:number, isTickUp:boolean = false) {
        const tl:TimelineLite = new TimelineLite();
        if(value <= this._showThreshold) {
            tl.add(() => this.clearText());
            return tl;
        }
        let scaleVale:number = value < 6 ? (1 + (value / 10)) : 1.6;
        tl.add(() => this.setText(value));
        tl.add(new TweenLite(this._dynamicText, 0.01, {alpha : 0}));
        if(isTickUp) {
            tl.add(new TweenLite(this._dynamicText, 0.01, {alpha : 1}));
            tl.add(new TweenLite(this._dynamicText.scale, 0.01, {x : 1.7, y : 1.7}));
            if(value.toString().length <= 1) {
                tl.add(new SpineTween(this._number, 0, value + "_fs"));
            } else {
                tl.add(() => this._dynamicText.position.x = -276);
            }
            tl.add(new TweenLite(this._dynamicText.scale, 0.06, {x : 1.7, y : 1.7}));
            tl.add(new TweenLite(this._dynamicText.scale, 0.8, {x : scaleVale, y : scaleVale}));

        } else {
            tl.add(() => this._dynamicText.position.x = -256);
            tl.add(new TweenLite(this._dynamicText, 0.01, {alpha : 1}));
            tl.add(new TweenLite(this._dynamicText.scale, 0.4, {x : scaleVale, y : scaleVale}));
        }

        return tl;
    }


    private getTurnOnAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let trackEntry = this._numberFire.state.tracks.filter((a) => {return a.animation.name === DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_START_TEXT});
        tl.add(new SpineTween(this._numberFire, 0, DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_FIRE_START), 0);
        tl.add(new SpineTween(this._numberFire, 0, DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_FIRE_LOOP, -1));
        if(trackEntry.length <= 0) {
            tl.add(new SpineTween(this._numberFire, 1, DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_START_TEXT), 0);
            tl.add(new SpineTween(this._numberFire, 1, DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_TEXT_LOOP, -1));
        }
        this._numberLastAnim = DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_TEXT_LOOP;
        return tl;
    }

    private getTurnOffAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new SpineTween(this._numberFire, 0, DirtyWildsSpineAnimationNames.TOP_BAR_NUMBER_FIRE_STOP), 0.2);
        return tl;
    }

}